'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDevicePlatform = getDevicePlatform;

var _AppConfigContainer = require('../globals/AppConfigContainer');

var _AppConfigContainer2 = _interopRequireDefault(_AppConfigContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getDevicePlatform() {
  var platform = void 0;

  if (_AppConfigContainer2.default.get('isMobile')) {
    if (_AppConfigContainer2.default.get('isAndroid')) {
      platform = 'android';
    } else if (_AppConfigContainer2.default.get('isIos')) {
      platform = 'ios';
    } else {
      platform = 'mobile';
    }
  } else {
    platform = 'desktop';
  }

  return platform;
}